import type { PropsWithChildren as PWC } from 'react';

import { Flex, Stack, Text } from '@myphx-engineering/phx-design-system';

import classes from './program-savings-card.module.css';

export const SavingsCardDetailsLabel = ({ children }: PWC) => (
    <Text className={classes.detailsLabel}>{children}</Text>
);

export const SavingsCardDetailsValue = ({ children }: PWC) => (
    <Text className={classes.detailsValue}>{children}</Text>
);

export const SavingsCardPatientInfo = ({ children }: PWC) => (
    <Flex gap="xxs">{children}</Flex>
);

export const SavingsCardDetailsField = ({ children }: PWC) => (
    <Stack classNames={{ root: classes.fieldWrapper }}>{children}</Stack>
);

export const SavingsCardDetailsGrid = ({ children }: PWC) => (
    <Flex classNames={{ root: classes.detailsWrapper }}>{children}</Flex>
);
